export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";